import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleXmark,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';

const SEO_ITEMS = [
  'Keywords on pages',
  'Backlinks',
  'Blog posts and SEO content',
];

const AEO_ITEMS = [
  'Structured data AI can read',
  'Credible context about your business',
  'Clear answers to customer questions',
];

export default function SeoVsAeoComparison() {
  return (
    <section className="flex flex-col items-center w-full px-4 md:px-0">
      {/* Headline area */}
      <div className="max-w-[640px] text-center">
        <h2 className="font-headline text-[32px] md:text-[40px] leading-[1.2] text-[#1e1c1c]">
          AI search is replacing Google. Your site was built for Google.
        </h2>
        <p className="font-body font-medium text-[16px] text-[rgba(30,28,28,0.7)] leading-[1.5] mt-3">
          Google rewards content. AI rewards clarity. Your site has one, not the
          other.
        </p>
      </div>

      {/* Desktop layout */}
      <div className="hidden md:flex w-full max-w-[800px] mt-12 gap-4">
        {/* Left column: What Google Needs */}
        <div className="flex-1 flex flex-col gap-4">
          <div className="flex items-center justify-center gap-[10px]">
            <FontAwesomeIcon
              icon={faCircleXmark}
              className="text-error text-[12px]"
            />
            <span className="font-body font-medium text-[16px] text-error">
              What Google Needs
            </span>
          </div>
          <div className="flex flex-col gap-3">
            {SEO_ITEMS.map((item, i) => (
              <div key={i} className="bg-[rgba(30,28,28,0.05)] rounded px-4 py-5 flex items-center gap-3">
                <span className="flex-1 font-body font-medium text-[16px] leading-[1.25] text-[rgba(30,28,28,0.5)]">
                  {item}
                </span>
                <FontAwesomeIcon
                  icon={faCircleXmark}
                  className={`text-[14px] shrink-0 ${i === 0 ? 'text-[#efeeee]' : 'text-error'}`}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Right column: What AI Needs */}
        <div className="flex-1 flex flex-col gap-4">
          <div className="flex items-center justify-center gap-[10px]">
            <FontAwesomeIcon
              icon={faCircleCheck}
              className="text-success text-[12px]"
            />
            <span className="font-body font-medium text-[16px] text-success">
              What AI Needs
            </span>
          </div>
          <div className="flex flex-col gap-3">
            {AEO_ITEMS.map((item, i) => (
              <div key={i} className="bg-[rgba(0,128,43,0.1)] rounded px-4 py-5 flex items-center gap-[6px]">
                <span className="flex-1 font-body font-semibold text-[16px] leading-[1.25] text-success">
                  {item}
                </span>
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="text-success text-[14px] shrink-0"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile layout */}
      <div className="md:hidden w-full mt-8 flex flex-col gap-6">
        {/* What Google Needs */}
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon
              icon={faCircleXmark}
              className="text-error text-[12px]"
            />
            <span className="font-body font-medium text-[16px] text-error">
              What Google Needs
            </span>
          </div>
          {SEO_ITEMS.map((item, i) => (
            <div key={i} className="bg-[rgba(30,28,28,0.05)] rounded px-4 py-5 flex items-center gap-3">
              <span className="flex-1 font-body font-medium text-[16px] leading-[1.25] text-[rgba(30,28,28,0.5)]">
                {item}
              </span>
              <FontAwesomeIcon
                icon={faCircleXmark}
                className={`text-[14px] shrink-0 ${i === 0 ? 'text-[#efeeee]' : 'text-error'}`}
              />
            </div>
          ))}
        </div>

        {/* What AI Needs */}
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon
              icon={faCircleCheck}
              className="text-success text-[12px]"
            />
            <span className="font-body font-semibold text-[16px] text-success">
              What AI Needs
            </span>
          </div>
          {AEO_ITEMS.map((item, i) => (
            <div key={i} className="bg-[rgba(0,128,43,0.1)] rounded px-4 py-5 flex items-center justify-between">
              <span className="font-body font-semibold text-[16px] leading-[1.25] text-success">
                {item}
              </span>
              <FontAwesomeIcon
                icon={faCircleCheck}
                className="text-success text-[14px] shrink-0"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
